<template>
  <div>
    <el-collapse v-model="activeNames" accordion>
      <el-collapse-item
        v-for="item in menuList"
        :key="item.id"
        :name="item.id"
        style="margin-left: 10px"
      >
        <template slot="title">
          <span class="collapsetitle">{{ item.meta.title }}</span>
        </template>
        <div
          class="for"
          v-for="item2 in item.children"
          :key="item2.id"
          @click.stop="childrenChange(item2)"
        >
          <div
            :class="ActiveIndexd == item2.id ? 'item2ListActive' : 'item2List'"
          >
            <!-- <p class="squareTop square"></p> -->
            <img
              class="squareTop square"
              style="width: 40px; position: absolute"
            />
            <div class="iconAndTitle">
              <div class="icon">
                <svg-icon
                  :icon-class="item2.meta.icon"
                  :class="
                    ActiveIndexd == item2.id
                      ? 'ThirdactiveIcon'
                      : 'ThirdnoActiveIcon'
                  "
                ></svg-icon>
              </div>
              <p
                :class="
                  ActiveIndexd == item2.id
                    ? 'ThirditemTitle1'
                    : 'ThirditemTitle2'
                "
              >
                {{ item2.meta.title }}
              </p>
            </div>
            <img
              class="squareBtm square"
              style="width: 40px; position: absolute"
            />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  props: ["item", "activeIndex", "ChildrenactiveIndex", "fatherId"],
  mounted() {
    this.menuList.forEach((item) => {
      if (item.children) {
        item.children.forEach((item2, index) => {
          if (item2.hidden) {
            item.children.splice(index, 1);
          }
        });
      }
    });
  },
  data() {
    return {
      menuList: this.item,
      showSecond: false,
      firstid: "",
      activeNames: this.fatherId,
      ActiveIndexd: this.activeIndex,
    };
  },
  methods: {
    show(val) {
      this.firstid = val.id;
      this.showSecond = !this.showSecond;
    },
    childrenChange(item) {
      this.ActiveIndexd = item.id;
      this.$router.push({ path: item.path });
    },
  },
  watch: {
    item: {
      handler: function (newValue) {
        this.menuList = newValue;
      },
      deep: true,
    },
    fatherId: {
      handler: function (newValue) {
        this.activeNames = newValue;
      },
      deep: true,
    },
    activeIndex: {
      handler: function (newValue) {
        this.ActiveIndexd = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.clear {
  clear: both;
}
/deep/ .el-collapse-item__content {
  background: rgb(122, 194, 158, 0);
  border-radius: 10px 0 0 10px;
  margin: 0;
  padding: 0;
}
/deep/.el-collapse-item__wrap {
  margin: 0 !important;
  padding: 0 !important;
  border: 0;
  background: rgb(122, 194, 158, 0);
  border-radius: 10px 0 0 10px;
  /* border-radius: 0 0 0 100px !important; */
}
/deep/ .el-collapse {
  background: rgb(122, 194, 158, 0);
  border: none;
  border-radius: 10px 0 0 10px;
  box-sizing: border-box;
}
/deep/.el-collapse-item__header {
  background: rgb(122, 194, 158, 0);
  border: none;
  color: white;
  height: 55px;
  box-sizing: border-box;
  font-size: 15px;
  font-weight: 500;
}
/* /deep/.el-collapse-item .is-active:first-child {
  height: 44px;
} */
/* /deep/.el-collapse-item__arrow {
  margin: 0;
  margin-right: 10px;
} */
.collapsetitle {
  margin-left: 10px;
}

.for {
  width: 150px;
  height: 60px;
  margin: 0;
  padding: 0;
  margin-bottom: 20px;
  position: relative;
  border-radius: 10px 0 0 10px;
  box-sizing: border-box;
}
.item2List {
  width: 150px;
  height: 60px;
  border-radius: 10px 0 0 10px;
  position: relative;
  /* line-height: 44px; */
  cursor: pointer;
}
.item2ListActive {
  width: 150px;
  height: 60px;
  background: #7ac29e;
  border-radius: 10px 0 0 10px;
  /* position: relative; */

  /* line-height: 44px; */
  cursor: pointer;
}
.iconAndTitle {
  margin: 21px 0 0px 0;
  height: 60px;
  border-radius: 10px 0 0 10px;
  box-sizing: border-box;
}
.item2ListActive .iconAndTitle {
  background: #ffffff;
  margin: 21px 0 0px 0;
  height: 60px;
  border-radius: 10px 0 0 10px;
  box-sizing: border-box;
}

.item2List .iconAndTitle {
  background: rgb(122, 194, 158, 0);
  /* margin: 10px 0 0 0; */
}
.item2ListActive > .square {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  box-sizing: border-box;
}
.item2List > .square {
  width: 8px;
  height: 8px;
  position: absolute;
  right: 0;
  display: none;
}
.item2ListActive > .square::after {
  content: "";
  width: 100%;
  height: 100%;
  background: rgb(1, 124, 1, 0);
  position: absolute;
  bottom: 0;
  right: 0;
}
.item2ListActive > .squareTop {
  top: -20px;
  content: url("~@/assets/images/corner.svg");
  /* background: url("@/assets/images/corner.svg"); */
}
.item2ListActive > .squareBtm {
  bottom: -20px;
  content: url("~@/assets/images/corner.svg");
  transform: rotate(-90deg);
}
.item2ListActive > .squareTop::after {
  border-radius: 0 0 50% 0;
}
.item2ListActive > .squareBtm::after {
  border-radius: 0 50% 0 0;
}
.ThirdactiveIcon {
  color: #3d91b5;
  text-align: center;
  vertical-align: middle;
  width: 25px;
  height: 25px;
  margin-left: calc(50% - 15px);
  margin-top: 10px;
  margin-bottom: 3px;
  fill: currentColor;
  overflow: hidden;
}
.ThirdnoActiveIcon {
  color: white;
  text-align: center;
  vertical-align: middle;
  width: 25px;
  height: 25px;
  margin-left: calc(50% - 15px);
  margin-top: 10px;
  margin-bottom: 3px;
  fill: currentColor;
  overflow: hidden;
}
.item2ListActive .svg-icon {
  /* color: #3d91b5; */
  text-align: center;
  vertical-align: middle;
  width: 25px;
  height: 25px;
  margin-left: calc(50% - 15px);
  /* margin-top: 10px;
  margin-bottom: 3px; */
  fill: currentColor;
  overflow: hidden;
}
.svg-icon {
  /* color: #ffffff; */
  text-align: center;
  vertical-align: middle;
  width: 25px;
  height: 25px;
  margin-left: calc(50% - 15px);
  margin-top: 10px;
  /* margin-bottom: 3px; */
  fill: currentColor;
  overflow: hidden;
}
.ThirditemTitle1 {
  text-align: center;
  cursor: pointer;
  /* color: #3d91b5; */
  margin: 0;
  padding: 0;
}
.ThirditemTitle2 {
  cursor: pointer;
  text-align: center;
  color: white;
  margin: 0;
  padding: 0;
}
</style>
